export const getTokenFromMetaTag = () => {
  const authTokenElement = document.querySelector(
    `meta[name="${csrfMetaTagName}"]`
  );

  if (!!authTokenElement) return authTokenElement.getAttribute('content');
};

export const HEADER_PARAM = 'X-CSRF-Token';

// this is where we keep our privates

const csrfMetaTagName = 'csrf-token';
